import { z } from 'zod'
import {
  abstractComponent,
  COMPONENT_TYPES,
} from '@customTypes/cloudmix/sessions/components/base'
import { v4 as uuidv4 } from 'uuid'
import { audioVideoPadSchema } from '../../pads'

export const scteEventIdSchema = z.number().or(z.string())
export const scteEventSchema = z.object({
  splice_start_ns: z.number(),
  splice_end_ns: z.number().optional(),
})
export const pendingScteEventsSchema = z.record(
  scteEventIdSchema,
  scteEventSchema
)

export const baseLiveOutputDestinationComponentSchema =
  abstractComponent.extend({
    type: z
      .literal(COMPONENT_TYPES.liveOutputDestination)
      .default(COMPONENT_TYPES.liveOutputDestination),
    liveOutputId: z.string().min(1, 'Live output ID is required'),
    input: audioVideoPadSchema.optional().default(() => {
      const id = uuidv4()
      return { name: id, displayName: id }
    }),
    enabled: z.boolean().default(false),
    recordingEnabled: z.boolean().nullish().default(false),
  })
export type BaseLiveOutputDestinationComponent = z.infer<
  typeof baseLiveOutputDestinationComponentSchema
>

export const projectLiveOutputDestinationComponentSchema =
  baseLiveOutputDestinationComponentSchema
export type ProjectLiveOutputDestinationComponent = z.infer<
  typeof projectLiveOutputDestinationComponentSchema
>

export const CONNECTION_STATE = {
  disconnected: 'disconnected',
  connecting: 'connecting',
  connected: 'connected',
} as const

export type ConnectionState =
  (typeof CONNECTION_STATE)[keyof typeof CONNECTION_STATE]

export const connectionStateSchema = z.enum([
  CONNECTION_STATE.disconnected,
  CONNECTION_STATE.connecting,
  CONNECTION_STATE.connected,
])

export const liveOutputDestinationComponentSchema =
  baseLiveOutputDestinationComponentSchema.extend({
    pendingScteEvents: pendingScteEventsSchema.optional(),
    isScteEnabled: z.boolean().optional(),
    connectionState: connectionStateSchema.optional(),
    retriesExhausted: z.boolean().optional(),
  })
